<script lang="ts">
	import { dldl, goto, yyyy, zzzz } from "../store.svelte";
	import { onMount, onDestroy, tick } from "svelte";
	import { fly } from "svelte/transition";

	import getTableNames from "./controlfunctions/getTableNames.svelte";
	import Idented from "./Idented.svelte";
	import LayerToggle from "./LayerToggle.svelte";
	import SummaryView from "./SummaryView.svelte";
	import Locator from "./Locator.svelte";
	import Legend from "./Legend.svelte";
	import Comments from "./idented/Comments.svelte";
	import { mapSearch } from "./controlfunctions/findForMe.svelte";

	import OutageCalculator from "../applets/_/OutageCalculator/OutageCalculator.svelte";
	import TriageApplet from "../applets/_/TriageApplet/TriageApplet.svelte";
	import EnergyBalance from "../applets/_/EnergyBalance/EnergyBalance.svelte";

	import Fa, { FaLayers, FaLayersText } from "svelte-fa";
	import {
		faSlash,
		faArrowLeft,
		faArrowRight,
		faDiceTwo,
		faDiceOne,
		fa1,
		fa2,
		faPlus,
		faBolt,
		faLocationDot,
		faMinus,
		faEllipsisVertical,
		faLayerGroup,
		faPlug,
		faCamera,
		faMagnifyingGlass,
		faTimes,
		faListUl,
		faChartPie,
		faMap,
	} from "@fortawesome/free-solid-svg-icons";
	import { quintIn } from "svelte/easing";

	import MenuItems from "./MenuItems.svelte";

	yyyy.ctrl = {
		layerList: [],
		expanded: false,
		showLayerToggle: false,
		control: undefined,
		showLocator: false,
	};

	let isReady: boolean = $state(false);
	let layerList;
	let expanded: boolean = $state(false);
	let showLayerToggle: boolean = $state(false);
	let showLocator: boolean = $state(false);
	let showLegend: boolean = $state(false);
	let control: string = $state("");
	let viewMode: string = $state("list"); // "list" or "summary"
	let cameraComponent: any = $state();
	let showPhasePanel: boolean = $state(false);

	// Initialize phase state
	if (!yyyy.map.phases) {
		yyyy.map.phases = { A: true, B: true, C: true };
	}

	// Camera control functions
	const handleCameraFlip = () => {
		zzzz.emit("camera-flip");
	};

	const handleCameraCapture = () => {
		zzzz.emit("camera-capture");
	};

	// Reset viewMode to "list" when interaction changes to something other than "mapEnergized"
	$effect(() => {
		if (yyyy.ctrl.interaction !== "mapEnergized") {
			viewMode = "list";
		} else {
			viewMode = "summary";
		}
	});

	let exit = () => {
		console.log("Exit called - searchActive:", searchActive, "searchValue:", searchValue);
		// If search is active and has text, clear the text and keep search open
		if (searchActive && searchValue.length > 0) {
			console.log("Clearing search text, keeping box open");
			searchValue = "";
			yyyy.ctrl.searchTerm = "";
			// Keep searchActive = true so the search box stays open
			return;
		}
		// If search is active but empty, close the search box
		if (searchActive) {
			console.log("Closing search box");
			searchActive = false;
			searchValue = "";
			yyyy.ctrl.searchTerm = "";
			// Don't clear control/idnt here, just close search
			return;
		}
		// Clear control and idnt when exiting
		yyyy.ctrl.control = undefined;
		delete yyyy.map.idnt;
		// If expanded, collapse it
		if (yyyy.ctrl.expanded) {
			zzzz.emit("clear-energized");
			yyyy.ctrl.expanded = false;
			yyyy.ctrl.searchTerm = "";
			zzzz.emit("makeSmall");
			return;
		}
		// Final exit - go dormant
		zzzz.emit("map-dormant");
	};

	let controller = (incontrol: string) => {
		console.log(yyyy.ctrl);
		yyyy.ctrl.expanded = true;
		yyyy.ctrl.control = incontrol;
	};

	let toggleViewMode = () => {
		viewMode = viewMode === "list" ? "summary" : "list";
	};

	/* stuff for the search box */
	let searchActive: boolean = $state(false);
	let searchInput: HTMLInputElement = $state();
	let searching: boolean = $state(false);
	let searchValue: string = $state("");
	let toggleSearch = async () => {
		searchActive = true;
		await tick(); // Wait until the DOM has been updated
		searchInput.focus();
	};

	let findForMe = async (searchtearm: string) => {
		searching = true;
		// Store search term in ctrl for access by other components
		yyyy.ctrl.searchTerm = searchtearm;
		let mapSearchData = await mapSearch(searchtearm);
		// await bookmarkSearch(searchtearm);
		// let placeSearchData = await placeSearch(searchtearm);
		console.log("Finally");
		yyyy.ctrl.control = "Idented";

		yyyy.ctrl.interaction = "mapClick";
		yyyy.ctrl.expanded = true;
		console.log("-------", mapSearchData, "---------------");
		yyyy.map.idnt = mapSearchData;
		searching = false;
	};

	let findForMeKeyDown = (event: KeyboardEvent) => {
		if (event.key === "Escape") {
			event.preventDefault(); // Prevent browser from clearing the field
			exit();
			return;
		}
		if (event.key === "Enter" && searchValue.length > 0) {
			event.preventDefault();
			console.log("searching...");
			findForMe(searchValue);
		}
	};

	let zoom = (_: string) => zzzz.emit("zoom", _);

	let handlePhase = (phase: string) => {
		zzzz.emit("handlePhase", phase);
	};

	let isPulsing = $state(false);
	let phaseCloseTimeout: number | null = null;

	let toggleLocator = () => {
		showLocator = !showLocator;
		//	yyyy.map.locator.on = !yyyy.map.locator.on;
	};
	onMount(() => {
		dldl("Controls.svelte", "Controls.svelte mounted");
		//layerList = getTableNames();
		setTimeout(() => {
			isReady = true;
		}, 877.5);

		// Hide search box when find energized is clicked
		const handleFoundEnergized = () => {
			searchActive = false;
			searchValue = "";
			yyyy.ctrl.searchTerm = "";
		};

		// Pulse location button when annotation needs location
		const handlePulseLocationButton = () => {
			isPulsing = true;
			// Reset after animation completes
			setTimeout(() => {
				isPulsing = false;
			}, 3000);
		};

		// Auto-close phase panel after map click
		const handleMapClick = () => {
			if (showPhasePanel) {
				// Clear any existing timeout
				if (phaseCloseTimeout) {
					clearTimeout(phaseCloseTimeout);
				}
				// Set new timeout to close panel after 3 seconds
				phaseCloseTimeout = setTimeout(() => {
					showPhasePanel = false;
					phaseCloseTimeout = null;
				}, 3000);
			}
		};

		zzzz.on("foundEnergized", handleFoundEnergized);
		zzzz.on("pulse-location-button", handlePulseLocationButton);
		zzzz.on("map-click", handleMapClick);

		// Cleanup on component destroy
		return () => {
			zzzz.off("foundEnergized", handleFoundEnergized);
			zzzz.off("pulse-location-button", handlePulseLocationButton);
			zzzz.off("map-click", handleMapClick);
			if (phaseCloseTimeout) {
				clearTimeout(phaseCloseTimeout);
			}
		};
	});
</script>

{#if !yyyy.map.info}
	{#if isReady}
		<div id="side-controls">
			<span id="zoom-box" transition:fly={{ x: 250, delay: 1075 }}>
				<button onclick={() => zoom("+")} class="has-hint">
					<Fa icon={faPlus} size="1.5x" />
					<span class="hint">Zoom In</span>
				</button>
				<button onclick={() => zoom("-")} class="has-hint">
					<Fa icon={faMinus} size="1.5x" />
					<span class="hint">Zoom Out</span>
				</button>
			</span>
			<span class="tier-container active">
				<span id="tier-box" transition:fly={{ x: 250, delay: 875 }}>
					{#if yyyy.map.tierSelector}
						<!-- Primary button - above bolt when zoomed in -->
						<button 
							onclick={() => {
								yyyy.map.showPrimary = !yyyy.map.showPrimary;
								zzzz.emit("handleTierFilter");
							}} 
							class="has-hint"
							class:inactive={!yyyy.map.showPrimary}
						>
							<Fa icon={faDiceOne} size="1.5x" />
							<span class="hint">{yyyy.map.showPrimary ? 'Hide' : 'Show'} Primary</span>
						</button>
					{/if}
					
					<!-- Bolt button - always visible, toggles phase panel -->
					<button 
						onclick={() => {
							// Clear any existing timeout when manually toggling
							if (phaseCloseTimeout) {
								clearTimeout(phaseCloseTimeout);
								phaseCloseTimeout = null;
							}
							showPhasePanel = !showPhasePanel;
						}} 
						class="has-hint"
					>
						<Fa icon={faBolt} size="1.5x" />
						<span class="hint" class:shift-hint={showPhasePanel}>Toggle Phase & Electric Filters</span>
					</button>
					
					{#if yyyy.map.tierSelector}
						<!-- Secondary button - below bolt when zoomed in -->
						<button 
							onclick={() => {
								yyyy.map.showSecondary = !yyyy.map.showSecondary;
								zzzz.emit("handleTierFilter");
							}} 
							class="has-hint"
							class:inactive={!yyyy.map.showSecondary}
						>
							<Fa icon={faDiceTwo} size="1.5x" />
							<span class="hint">{yyyy.map.showSecondary ? 'Hide' : 'Show'} Secondary</span>
						</button>
					{/if}
				</span>
				
				{#if showPhasePanel}
					<span id="phase-panel" transition:fly={{ x: 250, duration: 300 }}>
						<div class="phase-group">
							<button
								class="phase-button phase-a has-hint"
								onclick={() => handlePhase("A")}
								class:inactive={!yyyy.map.phases.A}
							>
								<span>A</span>
								<span class="hint">Toggle Phase A</span>
							</button>
							<button
								class="phase-button phase-b has-hint"
								onclick={() => handlePhase("B")}
								class:inactive={!yyyy.map.phases.B}
							>
								<span>B</span>
								<span class="hint">Toggle Phase B</span>
							</button>
							<button
								class="phase-button phase-c has-hint"
								onclick={() => handlePhase("C")}
								class:inactive={!yyyy.map.phases.C}
							>
								<span>C</span>
								<span class="hint">Toggle Phase C</span>
							</button>
						</div>
						{#if yyyy.map.tierSelector}
							<div class="divider"></div>
							<button 
								onclick={() => {
									yyyy.map.showAdjunct = !yyyy.map.showAdjunct;
									zzzz.emit("handleAdjunct");
								}} 
								class="electric-button has-hint"
								class:inactive={!yyyy.map.showAdjunct}
							>
								<Fa icon={faPlug} size="1.25x" />
								<span class="hint">{yyyy.map.showAdjunct ? 'Show All Devices' : 'Electric Only'}</span>
							</button>
						{/if}
					</span>
				{/if}
			</span>

			<span
				id="layer-legend-box"
				transition:fly={{ x: 250, easing: quintIn, delay: 775 }}
			>
				<button
					id="layer-toggle"
					onclick={() => {
						showLayerToggle = true;
					}}
					class="has-hint"
				>
					<Fa icon={faLayerGroup} size="1.15x" />
					<span class="hint">Toggle Layers</span>
				</button>
				<button id="legend-button" onclick={() => showLegend = !showLegend} class="has-hint">
					<Fa icon={faMap} size="1.3x" />
					<span class="hint">{showLegend ? 'Hide Legend' : 'Show Legend'}</span>
				</button>
			</span>
			<span
				id="locator-box"
				class:pulse={isPulsing}
				transition:fly={{ x: 250, easing: quintIn, delay: 475 }}
			>
				<button id="gps-button" onclick={toggleLocator} class="has-hint">
					<FaLayers>
						<Fa icon={faLocationDot} size="1.5x" />
						{#if !showLocator}<Fa icon={faSlash} size="1.5x" />{/if}
					</FaLayers>
					<span class="hint">{showLocator ? 'Hide Location' : 'Show Location'}</span>
				</button>
			</span>
		</div>
	{/if}
{/if}

{#if isReady}
	<div
		id="instigator"
		class:expanded={yyyy.ctrl.expanded}
		transition:fly={{ x: -250, easing: quintIn, delay: 875 }}
	>
		<div id="line-one">
			{#if !searchActive}
				<button style="color: #ff3e00" onclick={exit}>
					{#if yyyy.ctrl.expanded}
						<Fa icon={faTimes} size="1.75x" />
					{:else}
						<Fa icon={faArrowLeft} size="1.75x" />
					{/if}
				</button>
				<span class="livewire-name"> {yyyy.sesh.activeLivewire.livewire}</span>
				<span class="control-buttons">
					{#if !yyyy.ctrl.expanded}
						<span>
							<button id="search-button" onclick={toggleSearch} style="color: #ff3e00">
								<Fa icon={faMagnifyingGlass} size="1.75x" />
							</button>
						</span>
						<span>
							<button
								id="menu-button"
								onclick={() => {
									controller("MenuItems");
								}}
								style="width: 28px; color: #ff3e00"
								><Fa icon={faEllipsisVertical} size="1.75x" /></button
							>
						</span>
					{/if}
				</span>
			{/if}
			{#if searchActive}
				<button style="color: #ff3e00" onclick={exit}>
					<Fa icon={faTimes} size="1.75x" />
				</button>
				<input
					id="find-for-me"
					type="search"
					bind:this={searchInput}
					bind:value={searchValue}
					onkeydown={findForMeKeyDown}
					class:is-loading={searching}
					placeholder="Search for anything...."
				/>
				{#if searchValue.length > 0}
					<button
						style="color: #ff3e00"
						onclick={() => {
							findForMe(searchValue);
						}}
					>
						<Fa icon={faArrowRight} size="1.75x" />
					</button>
				{/if}
			{/if}
		</div>

		<div class="content-container">
			{#if yyyy.ctrl.control === "MenuItems"}
				<MenuItems bind:expanded bind:control />
			{/if}

			{#if yyyy.ctrl.control === "OutageCalculator"}
				<OutageCalculator bind:expanded bind:control bind:searchActive />
			{/if}
			{#if yyyy.ctrl.control === "TriageApplet"}
				<TriageApplet bind:expanded bind:control bind:searchActive />
			{/if}
			{#if yyyy.ctrl.control === "EnergyBalance"}
				<EnergyBalance bind:expanded bind:control bind:searchActive />
			{/if}

			{#if yyyy.ctrl.control === "NewAnnotation"}
				<div class="new-annotation-container">
					<h3 class="annotation-title">New Annotation</h3>
					<Comments
						lw_id={0}
						iama="GENERAL"
						clkd={null}
						bind:expanded
						bind:control
						found={{ properties: { lw_table: "General", lw_id: 0 } }}
					/>
				</div>
			{/if}

			{#if yyyy.ctrl.control === "Idented"}
				<!-- View Mode Toggle - Only show when interaction is mapEnergized -->
				{#if yyyy.ctrl.interaction === "mapEnergized"}
					<div class="view-toggle-container">
						<button
							class="view-toggle-button"
							class:active={viewMode === "summary"}
							onclick={() => (viewMode = "summary")}
							title="Switch to summary view"
						>
							<Fa icon={faChartPie} />
							<span>Summary</span>
						</button>

						<button
							class="view-toggle-button"
							class:active={viewMode === "list"}
							onclick={() => (viewMode = "list")}
							title="Switch to list view"
						>
							<Fa icon={faListUl} />
							<span>List</span>
						</button>
					</div>
				{/if}

				<!-- Content Display -->
				{#if viewMode === "summary" && yyyy.ctrl.interaction === "mapEnergized"}
					<div class="summary-view">
						<SummaryView />
					</div>
				{:else}
					<div style="width: 100%">
						{#if yyyy.map.idnt && yyyy.map.idnt.length > 0}
							{#each yyyy.map.idnt as f, i (f.uniqueId)}
								{#if f.expanded}
									<div style="height: 5px"></div>
									<Idented found={f} {i} />
								{/if}
							{/each}
						{:else if searching}
							<div class="no-results">
								<p>Searching...</p>
							</div>
						{:else if searchActive && searchInput && searchInput.value.length > 0}
							<div class="no-results">
								<p>No results found for "{searchInput.value}"</p>
								<p class="no-results-hint">Try searching for a different term</p>
							</div>
						{/if}
					</div>
				{/if}

				<!-- Content Display -->
				<!-- Replace the content display section around line 231 -->

				<!-- Content Display -->
			{/if}
		</div>
	</div>
{/if}

{#if showLayerToggle}
	<LayerToggle bind:showLayerToggle />
{/if}

{#if showLocator}
	<Locator />
{/if}

{#if showLegend}
	<Legend bind:showLegend />
{/if}

<!--
{#if yyyy.map.locator.on}
	<Locator />
{/if}
-->

<style>
	#instigator {
		position: fixed;
		display: flex;
		flex-direction: column;
		left: 15px;
		top: 15px;
		background-color: #ffffffe0;
		width: 375px;
		height: 45px;
		padding-left: 8.775px;
		padding-right: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		overflow-y: hidden;
		/* transition: */
		/* 	height 2.5s ease, */
		/* 	padding-top 0.3s ease; */
	}

	#instigator > #line-one {
		width: 100%;
		min-height: 45px;
		align-items: center;
		position: sticky;
		top: 0;
		display: flex;
		justify-content: space-between;
		background-color: #ffffffe0;
		z-index: 10;
		padding: 0;
		margin: 0;
	}

	.content-container {
		width: 100%;
		padding-top: 5px;
	}

	@media only screen and (max-width: 475px) {
		#instigator {
			right: 15px;
			top: 5px;
			left: 15px;
			width: unset;
		}
		#instigator.expanded {
			height: unset;
			padding-top: 0;
			padding-bottom: 8.775px;
			overflow-y: auto;
			max-height: calc(100vh - 5px);
		}
	}

	#instigator.expanded {
		height: unset;
		padding-top: 0;
		padding-bottom: 8.775px;
		max-height: calc(95vh - 15px);
		overflow-y: auto;
	}

	.livewire-name {
		font-weight: bolder;
		padding-top: 2px;
	}

	#find-for-me {
		width: 100%;
		background-color: transparent;
		font-size: 1em;
		font-weight: bolder;
		padding-left: 8.775px;
		border: transparent;
		cursor: #ff3e00;
		caret-color: #ff3e00;
		caret-shape: block;
	}
	input[type="search"]::-webkit-search-cancel-button {
		-webkit-appearance: none;
		appearance: none;
	}

	#find-for-me:focus {
		outline: none;
		cursor: #ff3e00;
	}

	#side-controls {
		position: fixed;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		display: grid;
		grid-template-rows: auto auto auto auto;
		row-gap: 0;
		align-items: center;
	}
	
	#side-controls > span:not(.tier-container) {
		margin: 7.5px 0;
	}
	
	.tier-container {
		display: grid;
		place-items: center;
		position: relative;
		margin: 7.5px 0;
	}
	
	#phase-panel {
		position: absolute;
		right: calc(100% + 10px);
		top: 50%;
		transform: translateY(-50%);
		padding: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		display: flex;
		flex-direction: row;
		align-items: center;
		background-color: #ffffffe0;
		color: #ff3e00;
		gap: 8px;
	}
	
	.phase-group {
		display: flex;
		flex-direction: row;
		gap: 2px;
	}
	
	.phase-button {
		padding: 0.5rem 0.75rem;
		border: none;
		background: transparent;
		font-size: 1rem;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.2s;
		border-radius: 4px;
		min-width: 35px;
	}
	
	/* Phase A - Dark Red */
	.phase-button.phase-a {
		color: #982013;
	}
	
	.phase-button.phase-a:hover {
		background-color: rgba(152, 32, 19, 0.1);
	}
	
	/* Phase B - Green */
	.phase-button.phase-b {
		color: #19950c;
	}
	
	.phase-button.phase-b:hover {
		background-color: rgba(25, 149, 12, 0.1);
	}
	
	/* Phase C - Blue */
	.phase-button.phase-c {
		color: #18338b;
	}
	
	.phase-button.phase-c:hover {
		background-color: rgba(24, 51, 139, 0.1);
	}
	
	/* Inactive state for all phases */
	.phase-button.inactive {
		color: #999999;
		opacity: 0.5;
	}
	
	.phase-button.inactive:hover {
		background-color: rgba(150, 150, 150, 0.1);
		opacity: 0.7;
	}
	
	.divider {
		width: 1px;
		height: 24px;
		background-color: #ddd;
		margin: 0 4px;
	}
	
	.electric-button {
		padding: 0.4rem 0.6rem;
		border: none;
		background: transparent;
		color: #ff3e00;
		cursor: pointer;
		transition: all 0.2s;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.electric-button:hover {
		background-color: rgba(255, 62, 0, 0.1);
	}
	
	.electric-button.inactive {
		color: #999999;
		opacity: 0.6;
	}
	
	.electric-button.inactive:hover {
		color: #666666;
		opacity: 0.8;
	}

	#zoom-box {
		/* position: fixed; */
		/* right: 15px; */
		/* bottom: 55%; */
		padding: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		display: flex;
		flex-direction: column;
		background-color: #ffffffe0;
		color: #ff3e00;
		justify-content: space-around;
	}

	#tier-box {
		/* position: fixed; */
		/* right: 15px; */
		/* bottom: 150px; */
		padding: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		display: flex;
		flex-direction: column;
		background-color: #ffffffe0;
		color: #ff3e00;
		justify-content: space-around;
	}
	#layer-legend-box {
		padding: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		display: flex;
		flex-direction: column;
		background-color: #ffffffe0;
		color: #ff3e00;
		justify-content: space-around;
	}

	#locator-box {
		/* position: fixed; */
		/* right: 15px; */
		/* bottom: 45%; */
		padding: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		display: flex;
		flex-direction: column;
		background-color: #ffffffe0;
		color: #ff3e00;
		justify-content: space-around;
	}

	.control-buttons {
		display: flex;
		justify-content: space-between;
		width: 65px;
	}

	.view-toggle-container {
		display: flex;
		background-color: #f5f5f5;
		border-radius: 6px;
		padding: 4px;
		margin-bottom: 10px;
		border: 1px solid #dbdbdb;
	}

	.view-toggle-button {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 8px 12px;
		background: transparent;
		border: none;
		border-radius: 4px;
		color: #4a4a4a;
		cursor: pointer;
		transition: all 0.2s ease;
		gap: 6px;
	}

	.view-toggle-button:hover {
		background-color: rgba(255, 62, 0, 0.1);
	}

	.view-toggle-button.active {
		background-color: white;
		color: #ff3e00;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		font-weight: 500;
	}

	.no-results {
		padding: 2rem 1rem;
		text-align: center;
		color: #666;
	}

	.no-results p {
		margin: 0.5rem 0;
		font-size: 1rem;
	}

	.no-results-hint {
		font-size: 0.9rem;
		color: #999;
		font-style: italic;
	}

	.new-annotation-container {
		padding: 1rem;
		width: 100%;
	}

	.annotation-title {
		margin: 0 0 1rem 0;
		color: #363636;
		font-size: 1.1rem;
		font-weight: 600;
		border-bottom: 1px solid #eee;
		padding-bottom: 0.5rem;
	}

	/* Global Camera Modal - Full Screen */
	.camera-modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: #000;
		z-index: 10000; /* Highest z-index to be above everything */
		display: flex;
		flex-direction: column;
	}

	.camera-modal-content {
		display: flex;
		flex-direction: column;
		height: 100vh;
		background-color: #000;
	}

	.camera-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		background-color: rgba(0, 0, 0, 0.9);
		color: white;
		position: relative;
		z-index: 10;
		border-bottom: 1px solid #333;
	}

	.camera-header h3 {
		margin: 0;
		color: white;
		font-size: 1.1rem;
	}

	.camera-header-controls {
		display: flex;
		gap: 0.5rem;
		align-items: center;
	}

	.camera-control-btn {
		background: rgba(255, 255, 255, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		font-size: 1.1rem;
		cursor: pointer;
		color: white;
		padding: 0.5rem;
		border-radius: 50%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.2s;
	}

	.camera-control-btn:hover {
		background: rgba(255, 255, 255, 0.2);
		border-color: rgba(255, 255, 255, 0.4);
	}

	.camera-control-btn.capture-btn {
		background: rgba(50, 115, 220, 0.8);
		border-color: rgba(50, 115, 220, 1);
	}

	.camera-control-btn.capture-btn:hover {
		background: rgba(50, 115, 220, 1);
		border-color: rgba(50, 115, 220, 1);
	}

	.camera-control-btn.close-btn {
		background: rgba(241, 70, 104, 0.8);
		border-color: rgba(241, 70, 104, 1);
	}

	.camera-control-btn.close-btn:hover {
		background: rgba(241, 70, 104, 1);
		border-color: rgba(241, 70, 104, 1);
	}

	#locator-box {
		transition: all 0.2s ease;
	}

	#locator-box.pulse {
		animation: pulse 1s ease-in-out 3;
	}

	@keyframes pulse {
		0% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgba(255, 87, 51, 0.7);
		}
		70% {
			transform: scale(1.1);
			box-shadow: 0 0 0 10px rgba(255, 87, 51, 0);
		}
		100% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgba(255, 87, 51, 0);
		}
	}

	/* Hint tooltips */
	.has-hint {
		position: relative;
	}

	.hint {
		position: absolute;
		right: calc(100% + 10px);
		top: 50%;
		transform: translateY(-50%);
		background: #363636;
		color: white;
		padding: 5px 10px;
		border-radius: 4px;
		font-size: 12px;
		white-space: nowrap;
		pointer-events: none;
		opacity: 0;
		transition: opacity 0.2s ease;
		z-index: 1000;
	}

	.hint::after {
		content: '';
		position: absolute;
		left: 100%;
		top: 50%;
		transform: translateY(-50%);
		border: 5px solid transparent;
		border-left-color: #363636;
	}

	.has-hint:hover .hint {
		opacity: 1;
	}
	
	/* Hide hint when phase panel is open */
	.hint.shift-hint {
		display: none;
	}

	/* Inactive button state */
	button.inactive {
		color: #999999 !important;
		opacity: 0.6;
	}
	
	button.inactive:hover {
		color: #666666 !important;
		opacity: 0.8;
	}
</style>
